export default __webpack_public_path__ + "static/media/mocha.44308cc9.png";